import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap font-display font-semibold text-base leading-5 transition-all duration-200 ease-out focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-purple-500 focus-visible:ring-offset-2 disabled:pointer-events-none active:scale-[0.97] [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-purple-500 text-white shadow-sm hover:bg-purple-600 active:bg-purple-700 disabled:bg-purple-200 disabled:text-white disabled:opacity-100",
        destructive:
          "bg-danger text-white shadow-sm hover:bg-danger/90",
        outline:
          "border-[1.5px] border-purple-500 bg-transparent text-purple-500 shadow-none hover:bg-purple-50",
        secondary:
          "border-[1.5px] border-purple-500 bg-transparent text-purple-500 hover:bg-purple-50",
        ghost: "text-purple-500 hover:bg-purple-50 hover:underline",
        link: "text-purple-500 underline-offset-4 hover:underline",
      },
      size: {
        default: "h-[52px] min-h-11 px-6 rounded-pill",
        sm: "h-9 px-4 rounded-pill text-sm",
        lg: "h-[52px] px-8 rounded-pill",
        icon: "h-11 w-11 rounded-pill",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
